export interface ChangelogEntry {
  version: string;
  date: string;
  notes: string[];
}

export const CHANGELOG: ChangelogEntry[] = [
  {
    version: "2.1.0",
    date: "2026-10-02",
    notes: [
      "AI-assisted initiative submission with a live completeness/relevance review",
      "New conversational \"guided\" way to submit an initiative, powered by AI",
      "AI-suggested scores to help when reviewing a Business or Technical submission",
    ],
  },
  {
    version: "1.0.0",
    date: "2026-05-20",
    notes: ["Initial release"],
  },
];
